// utils/cookieUtils.ts
export const setCookie = (name: string, value: string, days: number) => {
  const site = process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? "tropicalsky.co.uk" : "tropicalsky.ie"
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const cookieString = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; domain=.${site}; SameSite=Lax; Secure`;
  // const cookieString = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/;  SameSite=Lax; Secure`;
  document.cookie = cookieString;
};

export const getCookie = (name: string) => {
  return document.cookie
    .split("; ")
    .find(row => row.startsWith(name + "="))
    ?.split("=")[1];
};
